import { fetchApi } from '@/config/axiosSetting';
import {
  GetCulpritCroquisSketchQueryParamsType,
  GetCulpritCroquisSketchQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCroquisSketch/getCulpritCroquisSketchQuery.type';

export const getCulpritCroquisSketchFunction = (
  params: GetCulpritCroquisSketchQueryParamsType,
): Promise<GetCulpritCroquisSketchQueryResponseType[]> => {
  return fetchApi.get(
    `property/reports/${params.id}/accident_users/culprit/images/croquis_image/`,
  );
};
